import type { IOrderServiceAddon } from '~/processes/providers/authorization/entity';

const ITEM_SIZE_VALUE_TYPE = '9';
const SIZE_VALUES_START_INDEX = 1;

const formatSizeValue = (value: string) => {
    const sizeValues = value
        .split('|')
        .map((size) => size.trim())
        .slice(SIZE_VALUES_START_INDEX, SIZE_VALUES_START_INDEX + 2);

    if (sizeValues.some((size) => !size)) {
        return '';
    }

    const sizeValue = sizeValues.join(' × ');

    return sizeValue ? `${sizeValue}` : '';
};

export const getServiceSize = (addons: IOrderServiceAddon[] = []) => {
    const sizeAddon = addons.find((addon) => addon.value_type === ITEM_SIZE_VALUE_TYPE);

    if (!sizeAddon?.aos_value) {
        return '';
    }

    try {
        return formatSizeValue(decodeURIComponent(sizeAddon.aos_value));
    } catch {
        return formatSizeValue(sizeAddon.aos_value);
    }
};
